import AuthApi from "../../../api/auth/AuthApi";
import * as React from "react";

const AuthContext = React.createContext<AuthApi | null>(null);
export default AuthContext;
